import React, { forwardRef } from 'react';
import { useRefresh } from 'react-admin';

import { DialogoDevolucao } from '../../Components';

const Container = forwardRef((props, ref) => {
  const refresh = useRefresh();
  function handleClose() {
    refresh();
  }
  return <DialogoDevolucao ref={ref} handleClose={handleClose} sessionId={0} />;
});

export default Container;
